import React from "react";
import Dropzone from "react-dropzone";
import StackGrid from "react-stack-grid";
import "../../../Styles/Upload.scss";
import { ListGroup, ListGroupItem } from "reactstrap";
import { fileService } from "../../../Services";
import { FeedbackFile } from "../../../Models/FeedbackFile";
import FeedbackFileManagerItem from "./FeedbackFileManagerItem";

const uuid = require("uuid");

type Props = {
  files: FeedbackFile[];
  onFilesAdded: (items: FeedbackFile[], isCadmakersOnly: boolean) => void;
  onFileDelete: (item: FeedbackFile) => void;
  isCadmakersOnly: boolean;
};

type State = {};

export default class FeedbackFileManager extends React.Component<Props, State> {
  onDrop = (files: File[]) => {
    this.props.onFilesAdded(
      fileService.filestoFeedbackFiles(files, this.props.isCadmakersOnly),
      this.props.isCadmakersOnly
    );
  };

  onPaste = (event: React.ClipboardEvent) => {
    this.props.onFilesAdded(
      fileService.fileListToFeedbackFiles(event.clipboardData.files, this.props.isCadmakersOnly),
      this.props.isCadmakersOnly
    );
  };

  onItemDelete = (item: FeedbackFile) => {
    this.props.onFileDelete(item);
  };

  render() {
    return (
      <div>
        <h4>{this.props.isCadmakersOnly ? "CadMakers Files" : "Files"}</h4>
        <ListGroup>
          {this.props.files
            .filter(x => x.isCadmakersOnly === this.props.isCadmakersOnly)
            .map((item: FeedbackFile) => (
              <FeedbackFileManagerItem
                file={item}
                onDelete={() => this.onItemDelete(item)}
                key={uuid()}
              />
            ))}
          <ListGroupItem onPaste={this.onPaste} key="dropzone">
            <Dropzone onDrop={this.onDrop} noClick noKeyboard>
              {({ getRootProps }) => (
                <div {...getRootProps()}>
                  <div style={{ color: "gray" }}>
                    Drop Files here or click the Upload button below
                  </div>
                </div>
              )}
            </Dropzone>
          </ListGroupItem>
        </ListGroup>
      </div>
    );
  }
}
